import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import index from '../views/index.vue'
import store from '../store' // 导入你的store
import { ElMessage } from 'element-plus'


const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'login',
    // 首页
    component: () => import('../views/login.vue'),
    meta: { requiresAuth: false , disable: false}
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    // 数据统计
    component: () => import('../views/dashboard.vue'),
    meta: { requiresAuth: false , disable: false}
  },
  {
    path: '/detail',
    name: 'detail',
    // 数据详情
    component: () => import('../views/detail.vue'),
    meta: { requiresAuth: false , disable: false, parentRoute: '/dashboard'}
  },
  {
    path: '/index',
    name: 'index',
    // 首页
    component: index,
    meta: { requiresAuth: false , disable: false}
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
      next();
})

export default router;
